import Button from 'components/base/Button';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Card, Col, FloatingLabel, Form, Row, Toast, ToastContainer } from 'react-bootstrap';

import { useAuth } from 'providers/AuthProvider'
import { useState, useEffect, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import FeedbackForm from './components/FeedbackForm';
import Dropzone from 'components/base/Dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RichTextEditor from 'components/base/RichTextEditor';

interface UpdateFeedbackProps {
    feedback_type: string;
}


const UpdateFeedback = ({ feedback_type }: UpdateFeedbackProps) => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Feedback'),
            url: '/feedback-dashboard'
        },
        {
            label: feedback_type === 'received' ? t('Received Feedbacks') : t('Given Feedbacks'),
            url: feedback_type === 'received' ? '/feedback-dashboard/received-feedbacks' : '/feedback-dashboard/given-feedbacks'
        },
        {
            label: feedback_type === 'received' ? 'Request a feedback' : 'Provide a feedback',
            active: true
        }
    ];

    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();

    // Query string
    //const queryParams = new URLSearchParams(location.search);
    //const feedback_id = queryParams.get('feedback_id');

    // Route parameters
    const { feedback_id } = useParams();

    // State to store existing contact data before update
    const [initialData, setInitialData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [files, setFiles] = useState<File[]>([]);

    // already uploaded file (resource)
    const [fileUrl, setFileUrl] = useState('');
    const [fileName, setFileName] = useState('');
    const [resourceId, setResourceId] = useState(0);


    const [notes, setNotes] = useState<string>('');
    const [feedbackText, setFeedbackText] = useState<string>('');


    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNotes(value);
    };




    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log('Submitting feedback...', initialData);
        const form = new FormData();
        //form.append('feedbackForm', JSON.stringify(formData['feedbackForm']));
        form.append('feedback_type', feedback_type);
        form.append('notes', notes);
        form.append('feedback', feedbackText);
        form.append('existing_file', resourceId ? resourceId + '' : '0');
        form.append('ref_feedback_id', initialData.ref_feedback_id || '0'); // vale null o il riferimento al feedback da dare

        // new file(s)
        files.forEach(file => {
            form.append('files', file);
        });

        try {
            const response = await apiClient.put(
                `/v1/feedbacks/${feedback_id}`, form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    const fetchFeedback = async () => {
        try {
            const { data } = await apiClient.get(`/v1/feedbacks/${feedback_id}`);
            //console.log('Feedback data:', data);
            const obj = {
                'feedback_from': data['feedback_from'],
                'feedback_to': data['feedback_to'],
                'feedback_title': data['feedback_title'],
                'feedback_type': data['feedback_type'],
                'job_role': data['job_role'],
                'inserted_at': data['inserted_at'].split(" ")[0],
                'ref_feedback_id': data['ref_feedback_id'], // vale null o il riferimento al feedback da dare
            };

            setResourceId(data['resource_id']);
            setFileUrl(data['resource_url']);
            setFileName(data['resource_name']);

            setInitialData(obj);
            setFeedbackText(data['feedback_content'] || ''); // se non c'è testo, setta a stringa vuota
            setNotes(data['notes']);

        } catch (error) {
            console.error('Error fetching feedback data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedback();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <ToastContainer className="p-3" position='top-center'>
                <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                    <Toast.Body className=''>{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>

            <PageBreadcrumb items={breadcrumbItems} />

            <Card className='mt-3 border border-light rounded-5' >
                <Card.Body>
                    <Form onSubmit={handleSumbit}>
                        <div className="border-bottom mb-4 mx-n3 px-2 mx-lg-n6 px-lg-6">
                            <div className="d-sm-flex justify-content-between">
                                <h2 className="mb-4">{t('UpdateFeedback.edit_feedback')}</h2>
                                <div className="d-flex mb-3">
                                    <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                        {t('Back')}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <Row>

                            <Col sm={8} md={8} style={{ minHeight: '150px' }}>

                                <RichTextEditor
                                    id="feedbackContent"
                                    value={feedbackText}
                                    onChange={setFeedbackText}
                                    placeholder={t('UpdateFeedback.content.placeholder')}
                                />
                                {/*
                                Cosa ho apprezzato
                                Cosa poteva andare meglio
                                Cosa potresti fare di diverso la prossima volta
                                What I have appreciated
                                What could have been better                                
                                What you could do differently next time
                                */}


                            </Col>
                            <Col>
                                <h4 className="mb-3">Peer</h4>
                                <div className='p-2 mb-3 bg-body-secondary border-bottom'>
                                    <h5 className="mb-3">{initialData.feedback_to}</h5>
                                    <h5 className="mb-3">Title: <span className='fw-medium'>{initialData.feedback_title}</span></h5>
                                    <h5 className="mb-3">Current role: <span className='fw-medium'>{initialData.job_role}</span></h5>
                                    <h5 className="mb-3">Requested on: <span className='fw-medium'>{initialData.inserted_at}</span></h5>
                                </div>

                                <h4 className="mb-3">My notes</h4>
                                <FloatingLabel
                                    controlId="feedback-notes"
                                    label={t('UpdateFeedback.notes')}
                                >
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '128px' }}
                                        type="text"
                                        name='notes' value={notes} onChange={handleNotesInputChange} />
                                </FloatingLabel>

                                <div className="mt-3 mb-5">

                                    {resourceId > 0 ? (
                                        <>
                                            <h4 className="mb-3">{t('UpdateFeedback.available_document')}</h4>
                                            <div className="d-flex bg-body-secondary">
                                                <div className="p-2 flex-grow-1 bg-body-secondary border-bottom">
                                                    <a href={`${fileUrl}`} target="_blank" rel="noopener noreferrer">
                                                        {fileName}
                                                    </a>
                                                </div>
                                                <div className="p-2 bg-body-secondary border-bottom">
                                                    <FontAwesomeIcon icon={faTrashCan} className="text-danger fs-8 me-1" onClick={() => setResourceId(-1)} />
                                                </div>

                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <h4 className="mb-3">{t('UpdateFeedback.add_document')}</h4>
                                            <Dropzone single={true}
                                                className="mb-3"
                                                onFileListUpdate={files => setFiles(files)}
                                                accept={{
                                                    'image/*': ['.png', '.gif', '.jpeg', '.jpg'],
                                                    'application/pdf': ['.pdf'],
                                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>


                        <div className="text-end">
                            <Button type="submit" variant="primary" className='mt-2'>{t('UpdateFeedback.save_feedback')}</Button>
                        </div>


                    </Form>
                </Card.Body>
            </Card>






        </>
    );

};

export default UpdateFeedback;
